import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {
  ENDPOINT_INSEE,
  ENDPOINT_INSEE_COMMUNES,
  ENDPOINT_INSEE_DEPARTEMENTS,
  ENDPOINT_INSEE_PAYS,
  ENDPOINT_INSEE_REGIONS
} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    pays: [],
    regions: [],
    departements: []
  },

  getCommunesByCodePostalLibelle(codePostalLibelle) {
    return axios
        .get(ENDPOINT_INSEE + ENDPOINT_INSEE_COMMUNES, { params : { codePostalLibelle }})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getAllDepartements() {
    if (this.state.departements.length === 0) {
      return axios.get(ENDPOINT_INSEE + ENDPOINT_INSEE_DEPARTEMENTS)
          .then(response => {
            this.state.departements = response.data;
            return this.state.departements;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.departements);
      });
    }
  },
  getAllRegions() {
    if (this.state.regions.length === 0) {
      return axios.get(ENDPOINT_INSEE + ENDPOINT_INSEE_REGIONS)
          .then(response => {
            this.state.regions = response.data;
            return this.state.regions;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.regions);
      });
    }
  },
  getAllPays() {
    if (this.state.pays.length === 0) {
      return axios.get(ENDPOINT_INSEE + ENDPOINT_INSEE_PAYS)
          .then(response => {
            this.state.pays = response.data;
            return this.state.pays;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.pays);
      });
    }
  }
};

export default store;
